import { MutationOptions, useMutation } from "react-query";
import { API_URL, APIError, APIResponse, post } from "../api";

function useResetPassword<T>(
  options?: MutationOptions<APIResponse<T>, APIError, Record<any, any>>
) {
  const {
    isLoading,
    isError,
    error,
    mutate: resetPassword,
  } = useMutation(
    async (variables: { email: string; code: string; password: string }) => {
      return await post(API_URL + "/auth/user/reset-password", variables, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
    },
    options
  );

  return {
    resetPassword,
    isLoading,
    isError,
    error,
  };
}

export default useResetPassword;
